export default "__VITE_ASSET__CLwuXn2K__"